import { useTranslation } from 'react-i18next';

export function useCommonLocalization() {
  return useTranslation('localization').t;
}
